import React from 'react';

import Head from 'next/head';

import {
  AdditionalServices,
  ProfessionalServices,
  SeoService,
  MonthlyPackage,
  ServicePrice,
  NotSpammingAgency,
  InvisibleToInvincible,
  SmartInvestment,
  Trusted,
  Cases,
  GetMarketingPlan,
  Road,
  PricingPlans,
  Faq,
} from '../../../components/seo/sections';

const SEOServices = props => {
  return (
    <>
      <Head>
        <title>Guaranteed SEO Services from Prodigi | Only Real Results</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/seo/professional-seo-services" />
        <meta
          name="description"
          content="Guaranteed SEO services in Yerevan starting at $1875/month. Get measurable results and expert support for your business. Contact us today!"
        />
        <meta property="og:url" content="https://weprodigi.com/seo/professional-seo-services" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Guaranteed SEO Services from Prodigi | Only Real Results" />
        <meta
          property="og:description"
          content="Guaranteed SEO services in Yerevan starting at $1875/month. Get measurable results and expert support for your business. Contact us today!"
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/professional-seo-service/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Service",
      "@id": "https://weprodigi.com/#seo-service",
      "name": "Professional SEO Services for Measurable Success",
      "description": "Improve your website's visibility with Prodigi's professional SEO services. Achieve higher search rankings and gain organic traffic.",
      "provider": {
        "@id": "https://weprodigi.com/#organization"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Yerevan"
        },
        {
          "@type": "Country",
          "name": "Armenia"
        }
      ],
      "serviceType": [
        "Technical SEO",
        "On-Page SEO",
        "Off-Page SEO",
        "Local SEO"
      ],
      "serviceOutput": "Improved keyword rankings and increased organic traffic",
      "audience": {
        "@type": "Audience",
        "audienceType": "Businesses seeking to improve online visibility"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Additional SEO Services",
        "itemListElement": [
          {
            "@type": "Service",
            "name": "SEO Consulting",
            "description": "Expert consulting to develop a customized SEO strategy."
          },
          {
            "@type": "Service",
            "name": "Content Marketing",
            "description": "Content creation and optimization to enhance SEO performance."
          },
          {
            "@type": "Service",
            "name": "Advanced Link Building",
            "description": "Strategic link-building campaigns to improve domain authority."
          },
          {
            "@type": "Service",
            "name": "PPC Integration",
            "description": "Combining SEO and paid ads for maximum visibility."
          },
          {
            "@type": "Service",
            "name": "Reputation Management",
            "description": "Managing online reputation to improve brand perception."
          }
        ]
      },
      "offers": [
        {
          "@type": "Offer",
          "name": "Plan for Activation",
          "priceSpecification": [
            {
              "@type": "PriceSpecification",
              "price": "2250",
              "priceCurrency": "USD",
              "description": "Initial Campaign Investment (1st month)"
            },
            {
              "@type": "PriceSpecification",
              "price": "1875",
              "priceCurrency": "USD",
              "description": "Progressive monthly optimizations (5 month commitment)"
            }
          ]
        },
        {
          "@type": "Offer",
          "name": "Plan for Acceleration",
          "priceSpecification": [
            {
              "@type": "PriceSpecification",
              "price": "3250",
              "priceCurrency": "USD",
              "description": "Initial Campaign Investment (1st month)"
            },
            {
              "@type": "PriceSpecification",
              "price": "2875",
              "priceCurrency": "USD",
              "description": "Progressive monthly optimizations (5 month commitment)"
            }
          ]
        },
        {
          "@type": "Offer",
          "name": "Plan for Victory",
          "priceSpecification": [
            {
              "@type": "PriceSpecification",
              "price": "4500",
              "priceCurrency": "USD",
              "description": "Initial Campaign Investment (1st month)"
            },
            {
              "@type": "PriceSpecification",
              "price": "4125",
              "priceCurrency": "USD",
              "description": "Progressive monthly optimizations (5 month commitment)"
            }
          ]
        },
        {
          "@type": "Offer",
          "name": "Comprehensive SEO Services",
          "priceSpecification": [
            {
              "@type": "PriceSpecification",
              "price": "1875",
              "priceCurrency": "USD",
              "description": "Typical monthly investment"
            },
            {
              "@type": "PriceSpecification",
              "price": "5000",
              "priceCurrency": "USD",
              "description": "High-end monthly investment"
            }
          ]
        }
      ],
      "video": {
        "@type": "VideoObject",
        "name": "SEO Services for Businesses",
        "description": "Improve your online visibility and organic search rankings with WeProdigi's comprehensive SEO services.",
        "thumbnailUrl": [
          "https://prnt.sc/E6Qob1sxuW7W"
        ],
        "uploadDate": "2023-08-24",
        "duration": "PT1M10S",
        "contentUrl": "https://weprodigi.com/uploads/images/seo/Arara_Video.mp4#t=0.1",
        "embedUrl": "https://weprodigi.com/uploads/images/seo/Arara_Video.mp4#t=0.1"
      },
      "mainEntityOfPage": "https://weprodigi.com/seo/professional-seo-services"
    },
    {
      "@type": "Product",
      "name": "Professional SEO Services for Measurable Success",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "bestRating": "5",
        "worstRating": "0",
        "ratingCount": "23"
      },
      "review": {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": 4,
          "bestRating": "5",
          "worstRating": "0"
        },
        "author": {
          "@type": "Person",
          "name": "Narek Gharibyan"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Unibank"
        },
        "datePublished": "2023-03-15",
        "reviewBody": "The service was very helpful in improving our website’s visibility and ranking. Highly recommend the team!"
      }
    },
    {
      "@type": "Organization",
      "@id": "https://weprodigi.com/#organization",
      "name": "WeProdigi",
      "url": "https://weprodigi.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://weprodigi.com/images/logovertical.svg",
        "width": 350,
        "height": 90
      },
      "telephone": "+374-44224226",
      "email": "info@weprodigi.com",
      "sameAs": [
        "https://x.com/WeProdigi",
        "https://www.youtube.com/@prodigi.agency",
        "https://www.linkedin.com/company/weprodigiagency/",
        "https://www.instagram.com/prodigi.agency/",
        "https://www.facebook.com/weprodigi/",
        "https://www.pinterest.com/prodigiagency/"
      ],
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "09:30",
          "closes": "18:30"
        }
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://weprodigi.com/#website",
      "url": "https://weprodigi.com/",
      "name": "ProDigi",
      "description": "The Digital Marketing Agency That Drives Results",
      "publisher": {
        "@id": "https://weprodigi.com/#organization"
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://weprodigi.com/?s={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      },
      "inLanguage": "en-US"
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.weprodigi.com/seo/professional-seo-services/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://weprodigi.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Professional SEO Services",
          "item": "https://www.weprodigi.com/seo/professional-seo-services/"
        }
      ]
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is SEO?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Search Engine Optimization (SEO) is the practice of improving the ranking of a website on search engines like Google. The goal is to increase website visibility through website optimization services."
          }
        },
        {
          "@type": "Question",
          "name": "How long does it take to see results from SEO Services?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "SEO is a long-term strategy. Typically, it takes a few months to see significant improvements."
          }
        },
        {
          "@type": "Question",
          "name": "How much do SEO services cost?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "SEO services generally range between $1,875 to $5,000 per month, depending on the scope of the project."
          }
        }
      ]
    }
  ]
}
`,
          }}
        />
      </Head>
      <SeoService />
      <ProfessionalServices />
      <AdditionalServices />
      <MonthlyPackage currency={props.currency} />
      <ServicePrice currency={props.currency} />
      <NotSpammingAgency />
      <InvisibleToInvincible />
      <SmartInvestment currency={props.currency} />
      <Trusted />
      <Cases />
      <GetMarketingPlan />
      <Road />
      <Faq />
      <PricingPlans currency={props.currency} />
    </>
  );
};

export default SEOServices;
